import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import findIndex from "lodash/findIndex";
import {FormattedMessage} from "react-intl";

import * as actions from '../../../../actions/actionFunctions';

export const addFilterArrayValue = (array, {filterId, filterGroupId}) => {
  let index = findIndex(array, {filterGroupId});
  if (index >= 0) {
    array.splice(index, 1, {filterId, filterGroupId})
  } else {
    array.push({filterId, filterGroupId});
  }
  return array;
};

class FilterSelection extends Component {

  static propTypes = {
    removeFilterSelection: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
    activePart: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      availableFilterValues: [],
      filterGroup: {}
    };
  }

  componentDidMount() {
    this.setAvailableFiltersValues(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.activePart && this.props.activePart && nextProps.activePart.partName !== this.props.activePart.partName) {
      this.setAvailableFiltersValues(nextProps);
    }
  }

  componentWillUnmount() {
    // this.setDefaultFilterValue();
  }

  /**
   * Fucntion is needed to find among filterGroups needed group & to return only those filters that has
   * at least 1 feature with it assigned
   * @param {Array} filterGroups
   * @param {String} filterGroupName
   * @param {Object} activePart
   * @param {Object} fabricatorData
   * @param {Array} selectedFilters // example: [{filterId: 1113, filterGroupId: 15}]
   * @return {Array} ArrayOf filterIds // example: [1231, 1587, 1596]
   */
  static getAvailableFilterValues(filterGroups, filterGroupName, activePart, fabricatorData, selectedFilters = []) {
    const availableFilterValues = [];
    const filterGroup = filterGroups.find(group => group.name === filterGroupName);
    if (filterGroup && activePart.featuresList) {
      const featuresToFind = (filterGroup.name === "Inlay Type") ? activePart.moduleParts : activePart.features;
      // console.log("featuresToFind", featuresToFind);
      // let missingFilters = {};
      featuresToFind.forEach((feature) => {
        if (feature.dbFeature.filterValueIDs[filterGroup.id] && selectedFilters.every(filterObject => {
            return feature.dbFeature.filterValueIDs[filterObject.filterGroupId]
              && feature.dbFeature.filterValueIDs[filterObject.filterGroupId].includes(filterObject.filterId)
          })) {
          feature.dbFeature.filterValueIDs[filterGroup.id].forEach((filterValue) => {
            if (!availableFilterValues.includes(filterValue)) {
              // console.log("feature with the filter:", feature);
              const fValue = filterGroup.values.find(val => val.id === filterValue);
              if (fValue) {
                if (fValue.value === "Slab") {  // we need to look for existing DuraBath Natural Stone features filter
                  if (!fabricatorData || (fabricatorData && !fabricatorData.isRebath)) {
                    // const duraBathNaturalStoneFilter = filterGroup.values.find(val => val.value === "DuraBath Natural Stone");
                    // if (!activePart.features.some(testFeature => {
                    //   return testFeature.dbFeature
                    //     && testFeature.dbFeature.filterValueIDs
                    //     && testFeature.dbFeature.filterValueIDs[filterGroup.id]
                    //     && testFeature.dbFeature.filterValueIDs[filterGroup.id].includes(duraBathNaturalStoneFilter.id)
                    // })) {
                    //   availableFilterValues.push(filterValue)
                    // }
                    availableFilterValues.push(filterValue)
                  }
                } else if (fValue.value === "DuraBath Natural Stone") {
                  if (!fabricatorData || (fabricatorData && fabricatorData.isRebath)) {
                    availableFilterValues.push(filterValue)
                  }
                  // const slabFilter = filterGroup.values.find(val => val.value === "Slab");
                  // if (!activePart.features.some.feature(testFeature => {
                  //   return testFeature.dbFeature && testFeature.dbFeature.filterValueIDs
                  //     && feature.dbFeature.filterValueIDs[duraBathNaturalStoneFilter.id]
                  // })) {
                  //   availableFilterValues.push(filterValue)
                  // }
                } else {
                  availableFilterValues.push(filterValue)
                }
              } else {
                // if (!missingFilters[filterValue]) {
                //   missingFilters[filterValue] = [feature]
                // } else {
                //   missingFilters[filterValue].push(feature)
                // }
              }
            }
          })
        }
      });
      // if (Object.keys(missingFilters).length) {
      //   console.error("Filter values are missing or wrong filter assigned!", missingFilters);
      //   console.info("Existing filters", filterGroup.values);
      // }
    }
    // console.log("availableFilterValues", availableFilterValues);
    return availableFilterValues
  }

  setAvailableFiltersValues(nextProps = this.props) {
    const filterGroup = nextProps.filterGroups.find(group => group.name === nextProps.filterGroupName);
    const availableFilterValues = FilterSelection.getAvailableFilterValues(
      nextProps.filterGroups, nextProps.filterGroupName, nextProps.activePart, this.props.fabricatorData
    );
    if (filterGroup) {
      this.setState({
        availableFilterValues,
        filterGroup
      })
    }
  }

  setActiveFilterValue = (filterId, filterGroupId) => {
    this.props.setSelectedFilters(addFilterArrayValue([...this.props.selectedFilters], {filterId, filterGroupId}));
    this.props.removeFilterSelection();
  };

  render() {

    // console.log('parentItem', this.props.parentItem);
    // console.log('activePart', this.props.activePart);
    // console.log('selectedFilters', this.props.selectedFilters);
    // console.log('availableFilterValues:', this.state.availableFilterValues);
    // let activeFilterValueId = null;
    // if (this.state.availableFilterValues.length && this.state.filterGroup && this.props.selectedFilters.length) {
    //   const appliedFilter = this.props.selectedFilters.find(filterObj => filterObj.filterGroupId === this.state.filterGroup.id);
    //   if (appliedFilter) {
    //     activeFilterValueId = appliedFilter.filterId
    //   }
    // }

    return this.state.availableFilterValues.length ? (
      <div className={this.props.isMobile ? "menu-wizard" : "panel-filters"}>
        <ul className="wiz-steps">
          <li className={"wiz-steps__item wiz-steps__item--all"}
              onClick={this.props.removeFilterSelection}>
            <FormattedMessage id="filterSelection.allItems"/>
          </li>
          {this.state.availableFilterValues.map((filterValueId, index) => {
            const filterValueObject = this.state.filterGroup.values.find(val => val.id === filterValueId);
            return (
              <li className={"wiz-steps__item wiz-steps__item--" + filterValueObject.value.replace(/ /g,"").toLowerCase()}
                  key={"filterValue"+index} onClick={() => this.setActiveFilterValue(filterValueId, this.state.filterGroup.id)}>
                <span>
                  <FormattedMessage id={filterValueObject.value}/>
                </span>
              </li>
            )
          })}
        </ul>
      </div>
    ) : null
  }
}

const mapStateToProps = (store) => ({
  filterGroups: store.filterState.filterGroups,
  fabricatorData: store.fabricatorState,
  selectedFilters: store.filterState.selectedFilters
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedFilters: (selectedFilters) => dispatch(actions.setSelectedFilters(selectedFilters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterSelection);
